<!-- Modal -->
<div class="load" *ngIf="loadingService.loading" id="exampleModal2" tabindex="-1">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-body text-center">
        <p><strong>{{loadingService.conteudo}}</strong></p>
        <div class="lds-css ng-scope d-flex justify-content-center">
          <div style="width:100%;height:100%" class="lds-eclipse">
            <div>
            </div>
          </div>
    <style type="text/css">@keyframes lds-eclipse {
          0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
          }
          50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
          }
          100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
          }
        }
        @-webkit-keyframes lds-eclipse {
          0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
          }
          50% {
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
          }
          100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
          }
        }
        .lds-eclipse {
          position: relative;
        }
        .lds-eclipse div {
          position: absolute;
          -webkit-animation: lds-eclipse 1s linear infinite;
          animation: lds-eclipse 1s linear infinite;
          width: 160px;
          height: 160px;
          top: 20px;
          left: 20px;
          border-radius: 50%;
          box-shadow: 0 10px 0 0 #93dbe9;
          -webkit-transform-origin: 80px 85px;
          transform-origin: 80px 85px;
        }
        .lds-eclipse {
          width: 200px !important;
          height: 200px !important;
          -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
          transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
        }
        </style>
      </div>

    </div>
  </div>
</div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared-layout/loading/loading.component.html